import { ExternalLink } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-[#070d33] text-white py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-4 gap-10 pb-10 border-b border-white/10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src="/assets/yuville-logo.png" alt="Yuville" className="w-12 h-12 object-contain" style={{ filter: 'brightness(0) invert(1)' }} />
              <div className="leading-none">
                <div className="font-bold text-lg">YUVILLE</div>
                <div className="text-brand-yellow text-[10px] tracking-[0.25em] font-semibold">INTERNATIONAL INC</div>
              </div>
            </div>
            <p className="text-white/60 text-sm max-w-md leading-relaxed mb-4">{t('footer.tagline')}</p>
            <p className="text-white/50 text-xs max-w-md leading-relaxed">
              {t('footer.shareholderOf')} <a href="https://qianyanholding.com" target="_blank" rel="noopener noreferrer" className="text-brand-yellow hover:underline inline-flex items-center gap-1">Qianyan Holdings (Shenzhen) Group Co. Ltd. <ExternalLink className="w-3 h-3" /></a>
            </p>
          </div>
          <div>
            <div className="text-brand-yellow text-xs font-bold tracking-widest uppercase mb-4">{t('footer.services')}</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="#trading" className="hover:text-brand-yellow transition">{t('footer.s1')}</a></li>
              <li><a href="#plateforme" className="hover:text-brand-yellow transition">{t('footer.s2')}</a></li>
              <li><a href="#plateforme" className="hover:text-brand-yellow transition">{t('footer.s3')}</a></li>
              <li><a href="#plateforme" className="hover:text-brand-yellow transition">{t('footer.s4')}</a></li>
              <li><a href="#plateforme" className="hover:text-brand-yellow transition">{t('footer.s5')}</a></li>
            </ul>
          </div>
          <div>
            <div className="text-brand-yellow text-xs font-bold tracking-widest uppercase mb-4">{t('footer.company')}</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="#apropos" className="hover:text-brand-yellow transition">{t('footer.c1')}</a></li>
              <li><a href="#partenariat" className="hover:text-brand-yellow transition">{t('footer.c2')}</a></li>
              <li><a href="#equipe" className="hover:text-brand-yellow transition">{t('footer.c3')}</a></li>
              <li><a href="#contact" className="hover:text-brand-yellow transition">{t('footer.c4')}</a></li>
            </ul>
          </div>
        </div>
        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <div data-testid="footer-copyright">© 2023–{new Date().getFullYear()} Yuville International inc. {t('footer.rights')}</div>
          <div>{t('footer.cities')}</div>
        </div>
      </div>
    </footer>
  );
}
